'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dibsTracking = require('dibs-tracking');

var _dibsTracking2 = _interopRequireDefault(_dibsTracking);

var _visitCountModel = require('./visitCountModel');

var _visitCountModel2 = _interopRequireDefault(_visitCountModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VisitorTracking = function () {
    function VisitorTracking() {
        _classCallCheck(this, VisitorTracking);

        this.model = new _visitCountModel2.default();

        this.model.incrementTracking();
        this.checkPdpEngaged(document);
        this.trackNonBouncePdp(_dibsTracking2.default);
        this.model.save();
    }

    /**
     * Was the prior page pdp?
     *
     * @param document
     * @property {number} priorPagePdp - is prior page PDP
     */


    _createClass(VisitorTracking, [{
        key: 'checkPdpEngaged',
        value: function checkPdpEngaged(document) {
            var value = 0;
            if (this.wasInPreviousUrl(document, '1stdibs.com') && this.wasInPreviousUrl(document, 'id-') || document.location.href.indexOf('id-') > -1) {
                value = 1;
            }
            this.model.set('priorPagePdp', value);
        }

        /**
         * check if nonBound Pdp Tracking event can be fired
         * @returns {boolean}
         */

    }, {
        key: 'canFireNonBoundPdpTracking',
        value: function canFireNonBoundPdpTracking() {
            return !this.model.get('gaTrackerEventFired') && this.model.get('priorPagePdp') && this.model.get('gaSessionPageCount') >= 2;
        }

        /**
         * @param  {Object} gaTracker [dibs-tracking wrapper around google analytics that fires events]
         * @return {None}
         */

    }, {
        key: 'trackNonBouncePdp',
        value: function trackNonBouncePdp(gaTracker) {
            if (this.canFireNonBoundPdpTracking()) {
                gaTracker.trackEvent({
                    'category': 'adwords',
                    'action': 'session type',
                    'label': 'nbpdp'
                });
                this.model.set('gaTrackerEventFired', 1);
            }
        }

        /**
         * Is the text in the url?
         * @returns {boolean}
         */

    }, {
        key: 'wasInPreviousUrl',
        value: function wasInPreviousUrl(document, linkText) {
            return document.referrer.indexOf(linkText) > -1;
        }
    }]);

    return VisitorTracking;
}();

exports.default = VisitorTracking;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-visit-tracking/dist/visitorTracking.js
// module id = ./node_modules/dibs-visit-tracking/dist/visitorTracking.js
// module chunks = 4